import Vue from 'vue'
import Router from 'vue-router'
import Account from "@/views/account/index"
import HotelCertification from "@/views/HotelCertification/index"
import ImportFile from "@/ImportFile"
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location)
}

Vue.use(Router)


export default new Router({
  //路径不加#号
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'ImportFile',
      component: ImportFile,
      children:[
        {
          path:'/',
          name:'home',
          component:()=>import("@/views/main/home/index")
        },
        {
          path:'/details',
          name:'details',
          component:()=>import("@/views/main/details/index")
        },
        {
          path:'/travelAgencyDetails',
          name:'travelAgencyDetails',
          component:()=>import("@/views/main/travelAgencyDetails/index")
        },
        {
          path:'/list',
          name:'list',
          component:()=>import("@/views/main/list/index")
        },
        {
          path:'/consult',
          name:'consult',
          component:()=>import("@/views/main/consult/index")
        },
        {
          path:'/consultDetails',
          name:'consultDetails',
          component:()=>import("@/views/main/consultDetails/index")
        },
        {
          path:'/askAQuestion',
          name:'askAQuestion',
          component:()=>import("@/views/main/askAQuestion/index")
        },
        {
          path:'/askAQuestionDetails',
          name:'askAQuestionDetails',
          component:()=>import("@/views/main/askAQuestionDetails/index")
        },
        {
          path:'/news',
          name:'news',
          component:()=>import("@/views/main/news/index")
        },
        {
          path:'/parse',
          name:'parse',
          component:()=>import("@/views/main/parse/index")
        },
        {
          path:'/AboutUs',
          name:'AboutUs',
          component:()=>import("@/views/main/AboutUs/index")
        },
        {
          path:'/authentication',
          name:'essentialInformation',
          component:()=>import("@/views/main/personal/authentication/index")
        },
        {
          path:'/personal',
          name:'personal',
          component:()=>import("@/views/main/personal/index"),
          children:[
            {
              path:'/personal',
              name:'essentialInformation',
              component:()=>import("@/views/main/personal/components/essentialInformation/index")
            },
            
            {
              path:'/personal/MyQuestion',
              name:'MyQuestion',
              component:()=>import("@/views/main/personal/components/MyQuestion/index")
            },
            {
              path:'/personal/MyAnswer',
              name:'MyAnswer',
              component:()=>import("@/views/main/personal/components/MyAnswer/index")
            },
            {
              path:'/personal/BuyVIP',
              name:'BuyVIP2',
              component:()=>import("@/views/main/personal/components/BuyVIP/index")
            },
            {
              path:'/personal/invitation',
              name:'invitation',
              component:()=>import("@/views/main/personal/components/invitation/index")
            },
            { 
              path:'/personal/MyCollection',
              name:'MyCollection',
              component:()=>import("@/views/main/personal/components/MyCollection/index")
            },
            {
              path:'/personal/Notice',
              name:'Notice',
              component:()=>import("@/views/main/personal/components/Notice/index")
            },
            {
              path:'/personal/hotelManagement',
              name:'hotelManagement',
              component:()=>import("@/views/main/personal/components/hotelManagement/index")
            }
          ]
        }
      ]
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
      children:[
        {
          path:'/account/login',
          name:'login',
          component:()=>import('@/views/account/login/index')
        },
        {
          path:'/account/selection',
          name:'accountSelection',
          component:()=>import('@/views/account/accountSelection/index')
        },
        {
          path:'/account/accountLogin',
          name:'accountLogin',
          component:()=>import('@/views/account/accountLogin/index')
        },
        {
          path:'/account/ForgetPassword',
          name:'ForgetPassword',
          component:()=>import('@/views/account/ForgetPassword/index')
        },
        {
          path:'/account/bindMobile',
          name:'bindMobile',
          component:()=>import('@/views/account/bindMobile/index')
        }
      ]
    },
    {
      path: '/HotelCertification',
      name: 'HotelCertification',
      component: HotelCertification,
      children:[
        {
          path:'/HotelCertification/contract',
          name:'contract',
          component:()=>import('@/views/HotelCertification/contract/index')
        },
        {
          path:'/HotelCertification/BuyVIP',
          name:'BuyVIP',
          component:()=>import('@/views/HotelCertification/BuyVIP/index')
        },
        {
          path:'/HotelCertification/VIPDescription',
          name:'VIPDescription',
          component:()=>import('@/views/HotelCertification/VIPDescription/index')
        },
        {
          path:'/HotelCertification/authentication',
          name:'authentication',
          component:()=>import('@/views/HotelCertification/authentication/index')
        },
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js